import { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import classNames from 'classnames';

import { Modal, Button, Input, Map } from '@/components/ui';
import { Search } from '@/components/SvgComponents';
import { SingleBranch } from './SingleBranch';

import styles from './index.module.scss';

const BranchModal = ({
  isActive,
  setIsActive,
  branchesData,
  setSelectedBranchInStore,
  handleGetAddress,
  defaultBranch,
}) => {
  const { t } = useTranslation();

  const defaultCoords = {
    lat: Number(branchesData?.[0].lat),
    lng: Number(branchesData?.[0].lng),
  };
  const [searchText, setSearchText] = useState('');
  const [filteredBranches, setFilteredBranches] = useState(branchesData);
  const [selectedBranch, setSelectedBranch] = useState(defaultBranch);
  const [center, setCenter] = useState(defaultCoords);
  const [isMobileBranches, setIsMobileBranches] = useState(false);

  useEffect(() => {
    setFilteredBranches(branchesData);
    if (!selectedBranch?.id) {
      setCenter(defaultCoords);
    }
    updateCenterCoords(selectedBranch?.id);
  }, [branchesData, selectedBranch]);

  const updateCenterCoords = (id) => {
    const currentBranch = branchesData?.find((branch) => branch?.id === id);
    const coords = {
      lat: parseFloat(currentBranch?.lat),
      lng: parseFloat(currentBranch?.lng),
    };
    setCenter(coords);
  };
  const searchHandler = (value) => {
    setSearchText(value);
    const filtered = branchesData?.filter(
      (branch) =>
        branch?.name
          ?.split(' ')
          .some((word) =>
            word?.toLowerCase()?.startsWith(value?.toLowerCase()),
          ) ||
        branch?.address
          ?.split(' ')
          .some((word) => word?.toLowerCase().startsWith(value?.toLowerCase())),
    );
    setFilteredBranches(filtered);
  };
  const submitHandler = () => {
    if (isMobileBranches) {
      setIsMobileBranches(false);
    }
    if (selectedBranch) {
      handleGetAddress(selectedBranch);
      setIsActive(false);
      setSelectedBranchInStore?.(selectedBranch?.id);
      updateCenterCoords(selectedBranch?.id);
    }
    setIsActive(false);
    setCenter(defaultCoords);
  };
  const branchHandler = (id, name) => {
    setSelectedBranch({ id, name });
    updateCenterCoords(id);
  };
  const cancelHandler = () => {
    setIsMobileBranches(false);
    setIsActive(false);
  };

  useEffect(() => {
    if (isActive) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isActive]);

  const handleModalActions = () => {
    setSearchText('');
    setIsActive();
    setSelectedBranch(defaultBranch);
    setCenter(defaultCoords);
  };

  return (
    <div
      className={styles.modalWrapper}
      itemScope
      itemType='https://schema.org/Organization'
    >
      <Modal active={isActive} setActive={handleModalActions}>
        <h1>{t('common:PickupPoint')}</h1>
        <div className={styles.customWrapper}>
          <div
            className={`${styles.left} ${
              isMobileBranches && styles.left__mobile
            }`}
          >
            <div className={styles.inputWrapper}>
              <Input
                value={searchText}
                onChange={(value) => searchHandler(value)}
                placeholder={t('device:address.branch')}
                onFocus={() => setIsMobileBranches(true)}
                type='validateGeneralInput'
              />
              <Search width={24} height={24} />
            </div>
            <div
              className={classNames(styles.branches, {
                [styles.branches__mobile]: isMobileBranches,
                [styles.scrollable]: filteredBranches?.length > 7,
              })}
            >
              {filteredBranches?.map(({ address, name, id }) => (
                <SingleBranch
                  key={id}
                  onClick={() => branchHandler(id, name)}
                  active={id === selectedBranch?.id}
                  branch={name}
                  adress={address}
                />
              ))}
            </div>
          </div>
          <div className={styles.right}>
            <Map
              branches={filteredBranches ?? branchesData}
              center={center}
              setCenter={setCenter}
              onMarkerClick={branchHandler}
              mobileSearch={isMobileBranches}
            />

            {!(!selectedBranch && isMobileBranches) && (
              <Button
                onClick={submitHandler}
                disabled={!selectedBranch?.id}
                className={styles.btnContinue}
              >
                {t('common:Continue')}
              </Button>
            )}
            {!selectedBranch && isMobileBranches && (
              <Button
                onClick={cancelHandler}
                className={styles.mobileBtn}
                variant='outline'
              >
                {t('common:Cancel')}
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default BranchModal;
